// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.card-content {\n        font-size: 18px;\n        /* padding-left: 14px; */\n        font-weight: 500 !important;\n        display: flex;\n        gap: 5px;\n}\n.card-content i{\n        /* width: 20px; */\n        margin-right: 5px;\n        text-align: center;\n        margin-top: 7px;\n}   \n", ""]);
// Exports
module.exports = exports;
